import React, { PureComponent, Fragment } from "react";
import SelectItem from "react-select";
const data = [
  { value: "2018", label: "2018" },
  { value: "2019", label: "2019" }
];
class SelectYear extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [{ label:2019, value: 2019 }]
    };
  }
  handleChange = event => {
    this.setState({ selectedItems: event });
    this.props.onChange(event.value);
  };

  render() {
    const { selectedItems } = this.state;
    return (
      <Fragment>
        <SelectItem
          onChange={this.handleChange}
          value={selectedItems}
          options={data}
        />
      </Fragment>
    );
  }
}

export default SelectYear;
